import moment from 'moment'

export class ParamsBuilder {
  constructor (timeRange, txnTypes, paymentTypes, statuses, sortOrder) {
    this.dateFormat = 'YYYY-MM-DD HH:mm:ss'
    if (!timeRange.includes(null)) {
      this.start_time = moment(timeRange[0]).format(this.dateFormat)
      this.end_time = moment(timeRange[1]).format(this.dateFormat)
    }
    this.txn_types = txnTypes
    this.payment_types = paymentTypes
    this.statuses = statuses
    this.sort_order = sortOrder
  }

  getParams () {
    delete this['dateFormat']
    let params = {}
    for (let varName in this) {
      if (this[varName] !== null && this[varName].length) {
        params[varName] = this[varName]
      }
    }
    return params
  }
}

export class DataBuilder {
  constructor (getterStatementFilter) {
    this.statementFilter = getterStatementFilter
  }

  getValue (param, date, defaultVal) {
    if (this.statementFilter.hasOwnProperty(param)) {
      if (date) {
        let dateTime = this.statementFilter[param].split(' ')
        let dateVal = new Date(dateTime[0])
        let timeVal = dateTime[1].split(':')
        dateVal.setHours(timeVal[0], timeVal[1], timeVal[2])
        return dateVal
      }
      return this.statementFilter[param]
    }
    return defaultVal || null
  }
}

export class FilterBuilder {
  constructor () {
    this.exportTypes1 = ['UPI_COLLECTIONS_EXPORT', 'TRANSACTION_EXPORT', 'INVALID_CREDIT_EXPORT', 'BULK_IMPORTS_EXPORT', 'INVALID_ENTRIES_EXPORT', 'PG_REFUNDS_EXPORT', 'PG_ORDERS_EXPORT']
    this.params1 = [{key: 'q', title: 'Search Term'}, {key: 'txn_type', title: 'Transaction Types'}, {key: 'txn_types', title: 'Transaction Types'}, {key: 'upi_id', title: 'UPI ID'}, {key: 'va_id', title: 'Virtual Account ID'}, {key: 'hypto_va_id', title: 'Virtual Account ID'}, {key: 'import_id', title: 'Import ID'}, 'date_range', 'start_time', 'end_time', 'payment_types', 'statuses', 'sort_order', 'file_name']
    this.params2 = ['date_range', {key: 'parent_id', title: 'Parent ID'}]
  }

  capitalize = (key) => {
    return key.split('_').map(e => e.charAt(0).toUpperCase() + e.slice(1)).join(' ')
  }

  process = (list, options, purpose) => {
    this.filtersList = list
    this.filterOptions = options
    if (this.exportTypes1.includes(purpose)) {
      this.appendList(this.params1)
    } else {
      this.appendList(this.params2)
    }
  }

  appendList = (params) => {
    params.reduce((list, param) => {
      let key = param
      let defaultTitle = null
      if (typeof param === 'object') {
        key = param['key']
        defaultTitle = param['title']
      }

      if (this.filterOptions[key]) {
        let title = defaultTitle || this.capitalize(key)
        let value = null

        if (key === 'sort_order') {
          value = this.filterOptions[key] === 'ASC' ? 'Oldest' : 'Latest'
        } else {
          value = typeof this.filterOptions[key] === 'object' ? this.filterOptions[key].join(', ') : this.filterOptions[key]
        }

        list.push({title, value})
      }
      return list
    }, this.filtersList)
  }
}
